import axios from "axios";

let API_BASE_URL = process.env.API_BASE_URL || "https://www.parknfly.lt:3443";
// let API_BASE_URL = process.env.API_BASE_URL || "https://localhost:3001";

export const postOrderStatus = async (orderId: string) => {
  const response = await axios.post(`${API_BASE_URL}/order-status`, { orderId: orderId });
  return response.data;
};